export default function toSpokenDate($filter) {
    var monthTranslations = {
        0: "DATE:JANUARY",
        1: "DATE:FEBRUARY",
        2: "DATE:MARS",
        3: "DATE:APRIL",
        4: "DATE:MAY",
        5: "DATE:JUNE",
        6: "DATE:JULY",
        7: "DATE:AUGUST",
        8: "DATE:SEPTEMBER",
        9: "DATE:OCTOBER",
        10: "DATE:NOVEMBER",
        11: "DATE:DECEMBER"
    };

    return (date, time) => {
        if (date) {
            date = moment(date);
            var monthName = $filter('translate')(monthTranslations[date.get('month')]);
            var timeString = time ? time.hour + ":" + time.minutes : date.format('HH') + ':' + date.format('mm');

            return date.date() + ' ' + monthName + ', ' + $filter('translate')('TIME:AT') + ' ' + timeString;
        }
    }
};